import { Injectable, NgZone } from '@angular/core';
import { ReplaySubject, Subject, Observable, of, throwError } from 'rxjs';
import {
  bufferTime, map, take, mergeMap, catchError, distinctUntilKeyChanged,
  distinctUntilChanged
} from 'rxjs/operators';
import { combineLatest } from 'rxjs/observable/combineLatest';
import { zip } from 'rxjs/observable/zip';
import { Store } from '@ngrx/store';
import 'rxjs/add/operator/filter';
import {
  IdataBinding,
  IbundleData,
  IFormSaveData,
  IGetFormsIdentifiers,
  Icontext,
  PatientParamsToSet,
  IfacillitiesInfo,
  Ifacillity
} from '../interfaces';
import { getQueryDataByIndex } from '../store/selectors';
import { BUNDLE_ACTIONS } from '../store/actions';
import { BundleCall } from './bundleCall.service';
import { uniqBy, uniq, find, cloneDeep, differenceWith, isEqual, isEmpty, unionWith, set, get, uniqWith, flatten, unset, filter as lodashFilter, isEqualWith , has, findIndex, isNull} from 'lodash';
import { configs } from './consts';
import { IgenomicsState } from '@ispm/core/interfaces/genomics-state.interface';
import { InterpolateService , InterpolationOptions } from '@ispm/shared/services/interpolate.service';
import { EVENT_ACTIONS } from '@ispm-client/modules/events/store/actions';
import {arrayKeyRenaming, ValidationLogic} from '../utils/arrayUtils';
import { filter } from 'rxjs/operators';
import { from } from 'rxjs';
import { ResourceDataItem } from '@ispm/core/classes/resource-data-item.class';
import { UpdateResourcesAction } from '@ispm/shared/store/actions/test-bar.actions';
import { FORM_ACTIONS } from '@ispm/dynamic-form/store/form.actions';
import { Map as immutableMap } from 'immutable';
import { TAGS } from '@ispm/dynamic-form/constants/FlagTypes';
import { CoreActionCreatorService } from '@ispm/core/services/core-action-creator.service';
import {ICustomPostCall, ISelectedFacilityAssociation} from '@ispm-client/modules/aggregator/interfaces';
import { FlattenService } from '@ispm-client/modules/aggregator/services/flatten.service';
import { TestBarActionTypes } from '@ispm/test/store/test-bar.actions';
import {WorkflowUtilService} from '@ispm-client/modules/aggregator/services/workflow-util.service';
import {FormulaService} from '@ispm/shared/services/formula.service';
import {UserActionCreatorService} from "@ispm/user/services/user-action-creator.service";
import {SessionStorageService} from "@ispm/shared/services/session-storage.service";
import { LogService } from '@ispm/core/services/log.service';
import { RouterManagerService } from '@ispm/core/services/router-manager.service';


@Injectable()
export class AgregationService {
  static INTERPOLATION_DEFAULT_OPTIONS: InterpolationOptions = {
    useEmptyValues: true,
    usePartialPath: true,
    clearUnresolvedPatterns: false
  };

  private formsQueryList: Array<any> = []; // this is required to give index as observable
  private interpolateCoreObject: any = { };
  private triggerBundle$: Subject<any> = new Subject();
  private store$: Store<any>;
  private testStore$: Store<any>;
  private usersKeystore$: Store<any>;

  private currentUser:any;
  private retriggerDepandantDatabindings: Array<IdataBinding> = [];
  private retriggerDatabindings: Array<IdataBinding> = [];
  private interPolatedDatabindings: Array<IdataBinding> = [];
  // TODO put in a const cannot import from table as this should be independent of any component
  private buttonStatusMap: Map<String, boolean> = new Map<String, boolean>();
  public formUpdatedNotification$: Subject<any> = new Subject<any>(); // used for formUpdate notification(if form was changed after initialization)
  readonly AGGREGATOR_SERVICE_CONTEXT = 'AGGREGATOR_SERVICE_CONTEXT';

  constructor(private genomicsStore: Store<IgenomicsState>,
              private _bundleCall: BundleCall, _zone: NgZone,
              private coreAC: CoreActionCreatorService,
              private _flattenService: FlattenService,
              private _workflowUtilService: WorkflowUtilService,
              private userAC: UserActionCreatorService,
              private session: SessionStorageService,
              private routerManagerService: RouterManagerService,
              private logservice: LogService
              ) {
    this.store$ = genomicsStore.select('bundleData') as any;
    this.testStore$ = genomicsStore.select('tests') as any;
    this.usersKeystore$ = genomicsStore.select('users') as any;
    this.genomicsStore.select('users','currentUser').subscribe(userData =>{
      this.currentUser = userData;
    });


    /*start and stop
    Rx.Observable.merge(
      start$.flatMapLatest(() => Rx.Observable.interval(1000).takeUntil(stop$)).map(() => 1),
    ) });*/
    _zone.runOutsideAngular(() => {
      this.triggerBundle$ // TODO buffer time as config
        .pipe(bufferTime(configs.bufferTime))// bufferTime looks better than debounce as currently only giving latest array vales
        .subscribe(queries => {
          if (queries.length > 0) {
            _zone.run(() => {

              this.callISPMServer(queries);
              // this.triggerBundle$.complete();
              // TODO stop triggerBundle
            });
          }

        });
    });
  }

  public registerQuery(queryitem: Array<IdataBinding>, identifier = null): Observable<any> {
    // TODO start triggerBundle observation
    // TODO use set not an array
    const loopitems = queryitem.map(async element => {
       if ((element.prefetch === undefined) || (element.prefetch === true)) {
        element = await this.queryFilling(element);
        return this.getStoreObservable(element);
      }
    });
    /**
     * If identifier is passed means caller want it to be stored and updated
     * also same sub resource type changed should trigger this
     */
    if ((identifier) && queryitem.length) {
      const  dataBindings = cloneDeep(queryitem);
      this.genomicsStore.dispatch({
        type: FORM_ACTIONS.ADD_DATABINDINGS,
        payload: { name: identifier, dataBindings }
      });
    }

  /** Resolve all the aysnc await and then do combine latest of all the store
   * observable return if its not empty that means store index in that
   * postion will always have identifier name if for some reason its
   * not there then this subscribe wont happen
   *
   */
  return  from(Promise.all(loopitems)).pipe(mergeMap(respromise => {
    return combineLatest(...respromise).pipe(map((eacharray: Array<any>) => eacharray.filter(oneDataObj => !(isEmpty(oneDataObj)))
    .filter(alldata => !isEmpty(alldata))));
  }));

}

  private getStoreObservable(element: IdataBinding, triggerDependant: boolean = false): Observable<any> {
    if (element.pathToStore) {
      return this.getStoreItemObservable(element.pathToStore, element)
    }
    if (element.noFetchOnlySave) { // Mostly this field is used for save only
      return of([]);
    }
    if(isEmpty(element.targetResource)) {
      console.error('Invalid dataBinding query  ', element);
    }
    if (triggerDependant) {
      const foundedQuery = this.formsQueryList.find(e => e === element.queryStringWithContext);
      if (!foundedQuery) {
        this.formsQueryList.push(element.queryStringWithContext);
        this.triggerBundle$.next(element);
      } else {
        this.retriggerDepandantDatabindings.push(element);
      }
    }
   else  if (!(this.formsQueryList.inArray(function (e) {
      return e === element.queryStringWithContext; // TODO right now its a string compare it can be more logic
    }))) {
      this.formsQueryList.push(element.queryStringWithContext);
      this.triggerBundle$.next(element);
    }
    if (element.isForceFetch) {
      this.triggerBundle$.next(element);
    }
    return this.store$.select(getQueryDataByIndex(this.formsQueryList.indexOf(element.queryStringWithContext), element.emitOnlyIfData))
      .pipe(filter(queryData => !(queryData === undefined)));
  }


  /** This is getting updated data from card which just saved.
   *  and saving the response in the store as per index of the
   * query. Then retriggering the all the queries of this subresourcetype
   */
  public UpdateDataToServer(payload: Array<IFormSaveData>, context: Array<Icontext> = [], customInterpolation = { }): Observable<any> {
    const otherPostEndpoints: Array<ICustomPostCall> = [];
    const responseStats: ReplaySubject<any> = new ReplaySubject(3);
    let affectedsubResourceType: Array<string> = [];
    const allQueryStringsCreate: Array<IdataBinding> = [];
    const allQueryStringsUpdate: Array<IdataBinding> = [];
    let arrayOfDatabindings: IdataBinding[] = [];
    const triggerDatabindings: Array<IdataBinding> = [];
    let allDatabindings: immutableMap<string, IdataBinding[]>;
    let reqbody = { };
    const newData = [];
    const updateData = [];
    let temDatabindings: Array<IdataBinding>;
    let temDatabinding: IdataBinding;

    this.genomicsStore.select('forms', 'dataBindings').pipe(take(1)).subscribe(databindings => {
      responseStats.next(configs.responses[0]);
      allDatabindings = cloneDeep(databindings);
      arrayOfDatabindings = flatten(allDatabindings.valueSeq().toArray());
      /** Filtering the Array of data bindings to remove all null queries */
      lodashFilter(arrayOfDatabindings, el => !isNull(el));
      try{
        /** Picking target resource from store and structuring data in the
         * format required by bundle update */
        payload.forEach(form => {
          temDatabindings = allDatabindings.get(form.formId);
          let formData  = form.formdata ? form.formdata : form.formData;
          let noSaveDatabindings = temDatabindings.filter(d => d.noSaveFetchOnly);

        formData.forEach(formDataItem => {
          const nestedFormId = formDataItem.formId;

          if (!(nestedFormId === form.formId)) {
            const childDatabindings = allDatabindings.get(nestedFormId);

            if (!isEmpty(childDatabindings)) {
              noSaveDatabindings = noSaveDatabindings.concat(childDatabindings.filter(d => d.noSaveFetchOnly));
            }
          }
        });

        if (formData.filter(data => data.hasOwnProperty('onlyUnique')).length > 0) {
          formData = uniqWith(form.formdata ? form.formdata : form.formData, function(arrVal, othVal) {
            return (arrVal.id === othVal.id);
          });
         }

        noSaveDatabindings.forEach(element => {
           if (element.neededForPost) {
             return;
           }
          delete formData[element.identifier];
         });

        delete formData['order'];

        formData.forEach((field) => {
          if (field.hasOwnProperty(TAGS.TAG_MODIFIED)) {
            if (!(field[TAGS.TAG_MODIFIED])) {
              return;
            }
          }

          noSaveDatabindings.forEach(element => {
            if (element.neededForPost) {
              return;
            }
            // delete field[element.identifier];
            unset(field, element.identifier);
          });

          delete field['onlyUnique'];
          delete field['order'];
          delete field[TAGS.TAG_MODIFIED];

          noSaveDatabindings.forEach(binding => {
            if (!binding.neededForPost) {
              delete formData[binding.identifier];
            }
          });

          temDatabinding = temDatabindings.find(function (obj) {
            return obj.identifier === field['_dataBindingIdentifier'] || (obj.formId === field['formId'] && !isEmpty(field['formId']));
          });

          reqbody = { };

          if (temDatabinding === undefined) {
            temDatabinding = find(arrayOfDatabindings, { 'identifier': field['_dataBindingIdentifier']});
            /** Above line is introducing a bug added this to support tumor
             *  where databinding of the currently saving item
             *  is not in the current form but its in some other form*/
          }

          // TODO potential bug for string field
          if (temDatabinding['noSaveFetchOnly']) {
            return;
          }

          affectedsubResourceType = this.retriggerNotNeeded(field['subResourceType'], affectedsubResourceType, temDatabinding['subResourceType']);
          reqbody['targetResource'] = temDatabinding['targetResource'];
          reqbody['partialUpdate'] = field['partialUpdate']; // Server side undefined is also handled so no explicit check
          reqbody['formId'] = field.formId || temDatabinding.formId;
          field = this.updateFieldFilling(field, temDatabinding, context);
          reqbody['data'] = field;

          if (!field['id']) {
            console.log('Id doesnt exist in the field data');
            if (temDatabinding.postEndPoint) {
              otherPostEndpoints.push({ url: temDatabinding.postEndPoint, payload: this.customEndpointPayload(temDatabinding, field, reqbody, customInterpolation),
                serviceName: temDatabinding.serviceName, method: temDatabinding.methodType});
            } else {
              newData.push(reqbody); // As bundle util api cannot do both create and update together at the time of coding
            }

            allQueryStringsCreate.push(temDatabinding);
          } else {
            if (temDatabinding.postEndPoint) {
              otherPostEndpoints.push({ url: temDatabinding.postEndPoint, payload: this.customEndpointPayload(temDatabinding, field, reqbody, customInterpolation),
                serviceName: temDatabinding.serviceName, method: temDatabinding.methodType});
            } else {
              updateData.push(reqbody);
            }

            allQueryStringsUpdate.push(temDatabinding);
          }
        });
      });
      }
      catch(err){
        console.error("Error thrown from aggregator update")
        responseStats.error(configs.responses[3]);
        return;
      }

      const observs = [];

      if (newData.length > 0) {
        // console.log({ queries: newData , ...(stopAllValidation && { validateFormData: false })});
        observs.push(
          this._bundleCall
            .createCall({ queries: newData})
            .pipe(
              catchError((err) => {
                console.log('Bundle Create call from Aggregator Failed');
                console.error(err);
                responseStats.next(configs.responses[3]);
                return throwError(err);
              })
            )
        );
      }

      if (updateData.length > 0) {
        observs.push(
          this._bundleCall
            .updateCall({ queries: updateData })
            .pipe(
              catchError((err) => {
                console.log('Bundle update call from Aggregator Failed');
                console.error(err);
                responseStats.next(configs.responses[3]);
                return throwError(err);
              })
            )
        );
      }

      if (otherPostEndpoints.length > 0) {
        observs.push(
          this._bundleCall
            .customEndPointCall(otherPostEndpoints)
            .pipe(
              catchError((err) => {
                console.log('Custom post endpoint call from Aggregator Failed');
                console.error(err);
                responseStats.next(configs.responses[3]);
                return throwError(err);
              })
            )
        );
      }

      if (observs.length == 0) {
        responseStats.next(configs.responses[2]);
      }

      zip(...observs).subscribe((val) => {
        const currQueryStrings = allQueryStringsCreate.concat(allQueryStringsUpdate);
        const resourceUpdateArray: ResourceDataItem[] = [];

        currQueryStrings.forEach((bindings, indexOfResource) => {
          if (bindings.noFetchOnlySave || bindings.targetResource === 'DiagnosticOrder') {
            resourceUpdateArray.push(new ResourceDataItem(val[indexOfResource], bindings.targetResource));
          }
        });

        if (resourceUpdateArray.length > 0) {
          this.store$.dispatch(new UpdateResourcesAction(
            uniqWith(resourceUpdateArray, (arrVal, othVal) => arrVal.resourceType === othVal.resourceType)
          ));
        }

        responseStats.next(Object.assign({},configs.responses[1],{response:val}));
        this.storeUpdate([].concat.apply([], val), false, currQueryStrings);
        const affectedArr = uniq(affectedsubResourceType);

        affectedArr.forEach(affected => {
          arrayOfDatabindings.forEach(bind => {
              if (bind && bind.subResourceType) {
                if ((typeof(bind.subResourceType) === 'object') && (bind.subResourceType['code'] === affected)) {
                  triggerDatabindings.pushIfNotExist(bind, (d =>
                     (d.queriString === bind.queryString) &&  (d.identifier === bind.identifier) &&
                     (d.additionalFields === bind.additionalFields)));
                } else if (bind.subResourceType === affected) {
                  triggerDatabindings.pushIfNotExist(bind, (d =>
                       (d.queriString === bind.queryString) &&  (d.identifier === bind.identifier) &&
                       (d.additionalFields === bind.additionalFields)));
                } else if (Array.isArray(bind.subResourceType)) {
                  if (bind.subResourceType.findIndex(subres => subres === affected) > -1) {
                    triggerDatabindings.pushIfNotExist(bind, (d =>
                       (d.identifier === bind.identifier) && (d.additionalFields === bind.additionalFields)));
                  }
                }
              }
          });
        });
        /** Retriggering the all the queries excluding just saved */
        const result = differenceWith(triggerDatabindings, currQueryStrings, isEqual);
       /** adding queries explicitly needs rertrigger */
       const forcetriggers = currQueryStrings.filter(queryStr => queryStr.retrigger === true);
       forcetriggers ? this.retrigger(result.concat(forcetriggers))
       : this.retrigger(result);
       this.retriggerDatabindings = result;
       // TODO can be optimised with single line avoiding is Equal
      });
    });

    return responseStats.asObservable();
  }



  /** This function used by tooltip service to get data from the store
   * of list of identifiers along with formid */
  public getIdentifierData(form: IGetFormsIdentifiers): Observable<any> {
    let databinding: Array<IdataBinding>;
    const currDatabindings = [];
    return this.genomicsStore.select('forms', 'dataBindings').pipe
    (take(1), mergeMap(databindings => {
      databinding = databindings.get(form.formId);
      form._dataBindingIdentifier.forEach(element => {
        databinding.forEach(binding => {
          if (element === binding.identifier) {
            currDatabindings.push(binding);
          }
        });
      });
      return this.ondemandRegister(currDatabindings);
    }));
  }

  public clearQueriesData() {
    this.formsQueryList = [];
    this.interPolatedDatabindings = [];
    this.store$.dispatch({
      type: BUNDLE_ACTIONS.CLEAR_QUERIES_DATA,
      payload: { }
    });
    this.store$.dispatch({
      type: EVENT_ACTIONS.CLEAR_EVENTS,
      payload: { }
    });
  }

  public clearQuerylist() {
    this.formsQueryList = [];
    this.interPolatedDatabindings = [];
  //  TODO clear session storage
    this.session.deletedo()
  }

  /** Calling bundle endpoint while removing unwanted stuff from payload */
  private callISPMServer(queries: Array<IdataBinding>, firstIteration = true) {
    this._bundleCall.searchCall({ queries: this.removeUnwantedInQuery(queries) }).subscribe(val => {
      this.storeUpdate(this.responeRestructure(val, queries), firstIteration, queries);
    },
      (error) => {
      this.coreAC.setErrorModal(true, 'Partial information got loaded', 'Only part of the data was loaded, click on the reload button to reload the page', 'Reload');
    });
  }

  public putDataAndQuery(data: any, queries: Array<IdataBinding>) {
    this.formsQueryList.push(queries[0].queryString);
    this.storeUpdate(data, true, queries);
  }

  private storeUpdate(data: any, iteration: boolean, queries: Array<IdataBinding>) {
    if (iteration) {
      this.store$.dispatch({
        type: BUNDLE_ACTIONS.UPDATE_QUERIES_DATA,
        payload: data
      });
    } else {

      this.postSaveHooks(data, queries);
      const newObject = { };
      const arrayIdentifiers = [];
      const objectIdentifiers = [];
      let databinding: IdataBinding;
      let uniqueQuery: string;
      const resourceUpdateArray: ResourceDataItem[] = [];
      const formData = queries.map(async (element, index) => {
        resourceUpdateArray.push(new ResourceDataItem(data[index], element.targetResource));
        let interpolated: IdataBinding = this.interPolatedDatabindings.find((obj) => this.getUniqueOrnot(element, obj));
        if (interpolated) {
          interpolated = await this.queryFilling(interpolated, 'interpolatedQuery');
          uniqueQuery = interpolated.identifier + '-' + interpolated.targetResource + '&' + interpolated.interpolatedQuery;
          newObject['index'] = this.formsQueryList.indexOf(uniqueQuery);
        } else {
          databinding = await this.queryFilling(element);
          newObject['index'] = this.formsQueryList.indexOf(databinding.queryStringWithContext);
        }
        newObject['_dataBindingIdentifier'] = element.identifier;
        if (element.identifierType === 'array') {
          newObject['content'] = Object.assign({ });
          newObject['content'] = data[index];
          if (element.pickFromPath) {
            newObject['content'] = get(data[index], element.pickFromPath);
           }
          arrayIdentifiers.push(Object.assign({ }, newObject));
        } else {
          newObject['data'] = { };
          newObject['data'][element.identifier] = data[index];
          if (!element.skipIdAndMeta) {
            newObject['data']['id'] = get(data[index], 'id');
            newObject['data']['meta'] = get(data[index], 'meta');
          }
          if (element.pickFromPath) {
            newObject['data'][element.identifier] = get(data[index], element.pickFromPath);
           }
          objectIdentifiers.push(Object.assign({ }, newObject));
        }
        return newObject;
      });
      Promise.all(formData).then(fData => {
        /*this.store$.dispatch(new UpdateResourcesAction(
          uniqWith(resourceUpdateArray, (arrVal, othVal) => arrVal.resourceType === othVal.resourceType)
           ));*/
          const tempData = arrayIdentifiers.reduce(function (r, a, index) {
          var identifierkey = a.identifier ? a.identifier : a._dataBindingIdentifier;
          set(r, `${a.index}.data.${identifierkey}`, get(r, `${a.index}.data.${identifierkey}`, []));
          r[a.index]['data'][identifierkey].push(a.content);
          r[a.index]['index'] = a.index;
          delete a['content'];
          a.identifier ? delete a['identifier']:delete a['_dataBindingIdentifier'];
          //delete r[index];
          // delete a[index];
          return r;
        }, Object.create(null));
        let finalArrays = [];
        Object.keys(tempData).forEach(key => {
          finalArrays = finalArrays.concat(tempData[key]);
        });
        this.store$.dispatch({
          type: BUNDLE_ACTIONS.ONE_FORM_UPDATE,
          payload: finalArrays.concat(objectIdentifiers)
        });
      });
    }
  }

  public ondemandRegister(queryitem: Array<IdataBinding>, triggerDependant: boolean = false): Observable<any> {
    const loopitems = queryitem.map(async element => {
      element = await this.queryFilling(element);
      return this.getStoreObservable(element, triggerDependant);
    });

    return  from(Promise.all(loopitems)).pipe(mergeMap(respromise => {
      if (triggerDependant) {
      if (this.retriggerDepandantDatabindings.length > 0) {
        this.retrigger(uniqBy(this.retriggerDepandantDatabindings, function (e) {
          return e.queryString && e.identifier;
        }));
        this.retriggerDepandantDatabindings = [];
      }
    }
      return combineLatest(...respromise).pipe(map((eacharray: Array<any>) => eacharray.filter(oneDataObj => !(isEmpty(oneDataObj)))
      .filter(alldata => !isEmpty(alldata))));
    }));
  }

  private retrigger(querys: Array<IdataBinding>) {
    let uniqueQuery: string;
    const loopitems = querys.map(async element => {
      let interpolated: IdataBinding = this.interPolatedDatabindings.find((obj) => this.getUniqueOrnot(element, obj));
      if (interpolated) {
        interpolated = await this.queryFilling(interpolated, 'interpolatedQuery');
        uniqueQuery = interpolated.identifier + '-' + interpolated.targetResource + '&' + interpolated.interpolatedQuery;
        element['index'] = this.formsQueryList.indexOf(uniqueQuery);
        element.queryString = interpolated.interpolatedQuery;
        element = await this.queryFilling(element);
      } else {
        element = await this.queryFilling(element);
        element['index'] = this.formsQueryList.indexOf(element.queryStringWithContext);
      }

      return element;
    });
    Promise.all(loopitems).then(respromise => {
      if (respromise.length > 0) {
        const queries = uniqBy(respromise, function (e) {
          return e.queryStringWithContext;
        });
        this._bundleCall.searchCall({ queries: this.removeUnwantedInQuery(queries) }).subscribe(val => {
          const datawithindex = this.appendStoreIndextodata(val, queries);
          this.store$.dispatch({
            type: BUNDLE_ACTIONS.UPDATE_INDEX_QUERIES_DATA,
            payload: datawithindex
          });
        });
      }
    }).catch(errorReason => {
      console.log('On Failure of Bundle search,the error response', errorReason);
    });
  }

  public responeRestructure(val, queries: Array<IdataBinding>): Array<any> {
    const dispatchData = [];
    let itemdata = [];
    let listOfAddFields = [];
    let resource;
    let responses;
    let tempdata = { };
    let memoFallbackValues = { };

    queries.forEach((query, index) => has(query, 'hasParentIdentifier')
      ? memoFallbackValues[query.identifier] = get(val[index].response.entry[0].resource, query.pickFromPath, '')
      : query);

    queries.forEach((query, index) => { // As indexes will be same
      listOfAddFields = query.additionalFields && query.additionalFields.split(',') || [];
      if (val && val[index] && val[index].response && val[index].response.entry && val[index].response.entry.length > 0) {
      responses = val[index].response.entry;
      if ((query.identifierType !== undefined) && (query.identifierType === 'array')) {
          itemdata = [];
          responses.forEach((element) => {
            resource = element.resource;
            delete resource.resourceType;
            itemdata.push(resource);
          });
          tempdata = { };
          tempdata[query.identifier] = itemdata;
          if (query.pickFromPath) {
            itemdata[query.identifier] = get(itemdata, query.pickFromPath);
           }
          dispatchData.push(tempdata);
        } else {
          itemdata = Object.assign({ });
          /*Remove bindingField support to extract values from response
          itemdata[query.identifier] = query.bindingField ? responses[0].resource[query.bindingField] : responses[0].resource;*/
        /**
         * Either skipIdAndMeta or noSaveFetchOnly should be set to true,therefore id and meta will be not there data .
         */
        if (!(query.skipIdAndMeta || query.noSaveFetchOnly)) {
            itemdata['id'] = responses[0].resource['id']; // TODO later these 3 lines needs to be removed as id and meta are already part of identifier
            itemdata['meta'] = responses[0].resource.meta;
          }
         if (query.isContextNeeded && responses[0].resource['context']) {
          itemdata['context'] = responses[0].resource['context'];
        }
        listOfAddFields.forEach(addField => {
            itemdata[addField] = responses[0].resource[addField];
          });

          itemdata[query.identifier] = this.fillDefaultIfExists(query, index, responses[0].resource, false, memoFallbackValues);
          dispatchData.push(itemdata);
        }
      } else {
        const emptydata = { };
        emptydata[query.identifier] = this.fillDefaultIfExists(query, index, val, true, memoFallbackValues);
        dispatchData.push(emptydata);
      }
    });
    return dispatchData;
  }

  /***
   * control will come here if return value is null|undefined|entry[]
   */
  fillDefaultIfExists(databind: IdataBinding, index: number, value: any, isValempty: boolean, memoFallbackValues: Object = {}): any {
    if (isValempty) {
      if (!(databind.defaultValue === undefined)) {
        if ((databind.defaultValueCondition) && (databind.defaultValueCondition.length)) {
          if (databind.defaultValueCondition.includes(String(value[index][databind.identifier]))) {
            return databind.defaultValue;
          }
          else {
            if (!isEmpty(memoFallbackValues) && has(databind, 'fallback.identifier')) {
              return get(memoFallbackValues, get(databind, 'fallback.identifier'), '');
            }
            return { };
          }
        } else {
          return databind.defaultValue;
        }
      } else {
        if (!isEmpty(memoFallbackValues) && has(databind, 'fallback.identifier')) {
          return get(memoFallbackValues, get(databind, 'fallback.identifier'), '');
        }
        return { };
      }
    }
    else if ((databind.defaultValue) && (databind.defaultValueCondition) && (databind.defaultValueCondition.length)
    && databind.defaultValueCondition.includes(String(value[databind.identifier]))) {
        return databind.defaultValue;
    } else {
      if (databind.pickFromPath) {
        return get(value, databind.pickFromPath);
      } else if (!isEmpty(memoFallbackValues) && has(databind, 'fallback.identifier')) {
        return get(memoFallbackValues, get(databind, 'fallback.identifier'), '');
      }
      return value;
    }
  }

  /***
   * Dependant data binding logic
   * Response of one data binding is fed to other databinding
   */
 /* private internalRegister(_dataBindings: Array<IdataBinding>) {
    this._dataBindings = _dataBindings;
    if (_dataBindings !== undefined) {
      let firstIteration = true;
      /**
       * For databing which are having prefetch false should be interpolated
       * with data returned from databindings prefetch true
       *
       **/
      // TODO find a single line logic by filter and/or omit
      /*const prefetch = lodashFilter(_dataBindings, function(o) { return ((o.prefetch === true) || (!o.hasOwnProperty('prefetch'))); });
      const interpolateAndfetch = lodashFilter(_dataBindings, function(o) {
        return  (o.hasOwnProperty('isDepandant') && (o.isDepandant === true)); });
      const noRestCallPickFromExisting = lodashFilter(_dataBindings, function(o) { return o.hasOwnProperty('pickerIdentifierPath'); });
      const resultinterpolateAndfetch = differenceWith(interpolateAndfetch, noRestCallPickFromExisting, isEqual);
      const actualPrefetch = differenceWith(prefetch, interpolateAndfetch, isEqual);
      this.registerQuery(actualPrefetch)
        /** Using filter below to avoid repainting the dynamic form if data was
        * same as what it recieved last time
        */
       /* .pipe(take(1))
        .subscribe((data) => {
          /** Not sure whether observable should be returned directly/Assining the form itself here
              As from array to object same identifier data will be lost
              Achieving distinct via varibale should do it differently
              */
         /* const responseData = Object.assign({ }, ...cloneDeep(data));
          if ((resultinterpolateAndfetch.length) && firstIteration) {
            firstIteration = false;
            this.interpolateAndRegister(resultinterpolateAndfetch, responseData);
          } else {
            // This is logic below is specifically used by Events alone needs revisiting
            if (noRestCallPickFromExisting.length) {
              const noRestData = this.pickDataFromLastDatabindingResponse(responseData, noRestCallPickFromExisting);
              const finalFormData  = Object.assign({ }, ...cloneDeep(noRestData));
              this.onBundleSubscribe(this.copyFromAnotherIdentifier(finalFormData, this._dataBindings));
              this.dataob$.next(null);
            }
            else {
              this.onBundleSubscribe(this.copyFromAnotherIdentifier(responseData, this._dataBindings));
              this.dataob$.next(null);
            }
          }
        });
    } else {
      this.dataob$.next(null);
    }
  }*/

  private async queryFilling(dataBinding: IdataBinding, interpolatedQuery: string = null): Promise<IdataBinding> {
    let queryString = '', queryStringWithContext = '';
    queryString = dataBinding.queryString;

    if ((dataBinding.additionalFields) && (!(queryString.includes('&_fieldslist=')))) {
      queryString += '&_fieldslist=' + dataBinding.additionalFields;
    }
    if (interpolatedQuery) {
      let interpolatedQueryString = dataBinding.interpolatedQuery;
      if ((dataBinding.additionalFields) && (!(interpolatedQueryString.includes('&_fieldslist=')))) {
        interpolatedQueryString += '&_fieldslist=' + dataBinding.additionalFields;
      }
      interpolatedQueryString = await this._bundleCall.queryFiller(interpolatedQueryString);
      dataBinding = Object.assign({ }, dataBinding, { interpolatedQuery: interpolatedQueryString });

    }

    queryStringWithContext = await this._bundleCall.queryFiller(queryString);
    dataBinding = Object.assign({ }, dataBinding, { queryString: queryStringWithContext });
    queryStringWithContext = dataBinding.identifier + '-' + dataBinding.targetResource + '&' + queryStringWithContext; // Uniqueness
    dataBinding.queryStringWithContext = queryStringWithContext;
    return dataBinding;
  }

  private updateFieldFilling(field: any, databinding: IdataBinding,  contexts: Array<Icontext>) {
    const _context: Array<Icontext> = [...contexts];
    field['resourceType'] = databinding['targetResource'];
    const patientContext = this._bundleCall.getPatientContext();
    if(patientContext) {
      const context: Icontext = {reference: patientContext, resourceType: 'Patient'};

      if (field['context']) {
        try {
          if (!this.patientContextExist(field['context'])) {
            _context.unshift(context);
          }
        }
        catch(err){
          console.error(err);
          throw err;
        }
        field['context'] = field['context'].concat(_context);
      } else {
        field['context'] = _context;
        field['context'].unshift(context);
        if (!find(_context, {resourceType: 'Patient'})) {
          field['context'].unshift(context);
        }
      }
      }
    else{
      field['context'] = field['context'] || [];
    }
    // For update calls where partialUpdate = true, remove subResourceType as it will be taken from db.
    if(field['id'] && (get(field, 'partialUpdate', true) != false) && has(field, 'subResourceType')) {
      delete field['subResourceType'];
    }
    delete field['data'];
    delete field['formId'];
    delete field['_dataBindingIdentifier'];
    delete field['partialUpdate'];
    return field;
  }

  private patientContextExist(context: Array<Icontext>) {
    if (!isEmpty(context)) {
      const patientContext = context.filter(contextItem => contextItem.resourceType === 'Patient');
      if (patientContext.length > 0) {
        const patientContextID = this.routerManagerService.parameters?.patientId;
        const isValidPatientID =  !isEmpty(patientContextID) && patientContext.some(context => context.reference === patientContextID);
        const recievedPatientID = patientContext[0].reference;
        // IF some reason the data is trying to get updated with a context which is not of current patient
        // Throw a popup of the same.
        if( isValidPatientID) {
          return true;
        } else {
          this.logservice.error('Patient context mismatch in the client. Current id =  `${patientContextID}` but got =  `${recievedPatientID}`',this.AGGREGATOR_SERVICE_CONTEXT);
          this.coreAC.setErrorModal(true,'Partial information got loaded in the client', 'Only part of the data was loaded, click on the reload button to reload the page', 'Reload');
          throw new Error('Patient context mismatch in the client');
        }
      }
      return false;
    }
    return false;
  }

  private removeUnwantedInQuery(queries: Array<IdataBinding>): Array<IdataBinding> {
    const sendQueries = [];
    let sendQuery = { };
    queries.forEach(element => {
      sendQuery = { };
      element = this.processUnInterpolated(element);
      sendQuery['queryString'] = element.queryString;
      sendQuery['targetResource'] = element.targetResource;
      sendQueries.push(sendQuery);
    });

    return sendQueries;
  }

  private appendStoreIndextodata(response: any, querys: Array<IdataBinding>): Array<any> {
    const formatteddata = this.responeRestructure(response, querys);
    const returnData = [];
    formatteddata.forEach((element, index) => {
      element['index'] = querys[index]['index'];
      returnData.push(element);
    });
    return returnData;
  }

  private retriggerNotNeeded(subrestype: any, affected: Array<string>, bindingSubres: any): Array<string> {
    if (subrestype !== undefined) {
      if (typeof(subrestype) === 'object') {
        if (configs.subresourcetypes.indexOf(subrestype['code']) === -1) {
            affected.pushIfNotExist(subrestype['code'], ((d) => (d === subrestype['code'])));
          }
        } else {
          affected.pushIfNotExist(subrestype, ((d) => (d === subrestype)));
        }
    } else if (bindingSubres !== undefined) {
      if (typeof(bindingSubres) === 'object') {
        if (configs.subresourcetypes.indexOf(bindingSubres['code']) === -1) {
            affected.pushIfNotExist(bindingSubres['code'], ((d) => (d === bindingSubres['code'])));
          }
        } else if (Array.isArray(bindingSubres)) {
          bindingSubres.forEach(element => {
            affected.pushIfNotExist(bindingSubres, ((d) => (d === element)));
          });
        }
        else {
          affected.pushIfNotExist(bindingSubres, ((d) => (d === bindingSubres)));
        }
      }
      return affected;
    }


/**
 *
 * @param query query string to interpolate
 * @param dataObj
 * @param global
 * @param additionalOptions
 */
  public interpolate(query: string, dataObj: any, global = false,
    additionalOptions: InterpolationOptions = AgregationService.INTERPOLATION_DEFAULT_OPTIONS): string {
    return this._bundleCall.interpolate(query, dataObj, global, additionalOptions);
  }

  public interPolateWithStore(query: string): Promise<string> {
    return this._bundleCall.queryFiller(query);
  }

  public interPolateWithSessionStorage(query: string): Promise<string> {
    return this._bundleCall.queryFillerForStore(query,"tests.diagnosticOrders.order");
  }

  public interPolateWithStoreQueries(queries: Array<string>): Observable<Array<string>> {
    return this._bundleCall.interPolateQueries(queries);
  }


  public interpolateWithCurrentInstance(query: string) {
    return this.interpolate(query, this.interpolateCoreObject);
  }

  /**
   *
   * currently returning promise it can be just a data return
   * @param paramsObject
   */
  public async getFieldFromStore(paramsObject: PatientParamsToSet): Promise<any> {
    return await this._bundleCall.getStateObservable().pipe(map((interpolateObject: any) =>
    {
       if (InterpolateService.hasInterpolationString(paramsObject.pathToField) && has(paramsObject, 'pathToPick')) {
         const patientId: string = this._bundleCall.interpolate(paramsObject.pathToField, interpolateObject);
         return get(interpolateObject, paramsObject.pathToPick).find( item => item.id === patientId);
       }
       return get(interpolateObject, paramsObject.pathToField);
    })).toPromise() as Promise<any>;
  }

  public getStoreItemObservable(pathToField: string, element?: IdataBinding): Observable<any> {
    return this._bundleCall.getStateProp(pathToField, element);
  }

  private processUnInterpolated(_dataBinding: IdataBinding): IdataBinding {
    if (!isEmpty(_dataBinding.queryString) && _dataBinding.queryString.includes('#')) {
      _dataBinding.queryString = _dataBinding.queryString.replace(/#.*object Object.*#/, '');
      _dataBinding.queryString = _dataBinding.queryString.replace(/#/g, '');
    }
    return _dataBinding;
  }
  public updateLoader(setOrUnset: boolean) {
    this._bundleCall.updateLoader(setOrUnset);
  }

  public isDeepEmpty(objOrArray: any, conditions: Array<any>): boolean {
    return ValidationLogic(objOrArray, conditions);
  }

  public getretriggerDatabindings(): Array<IdataBinding> {
    return this.retriggerDatabindings;
  }

  public setretriggerDatabindings(_retrigers: Array<IdataBinding>) {
    this.retriggerDatabindings = _retrigers;
  }


  public setPolatedDatabindings(interPolated: Array<IdataBinding>) {
      this.interPolatedDatabindings =
      unionWith(this.interPolatedDatabindings, interPolated, (item1, item2) => this.getUniqueOrnot(item1, item2));
      // console.log(this.interPolatedDatabindings);
      // console.log(interPolated);
  }

  private getUniqueOrnot(a: IdataBinding, b: IdataBinding): boolean {
    if (a.identifier === b.identifier) {
      if (a.justIdentifierMatch) {
        return true;
      }
      if (a.subResourceType || b.subResourceType) {
        if ((typeof(a.subResourceType) === 'object') && (typeof(b.subResourceType) === 'object')) {
          if (a.subResourceType.code === b.subResourceType.code) {
            if (a.additionalFields || b.additionalFields) {
              return a.additionalFields === b.additionalFields;
            } else {
              return true;
            }
        } else {
          return false;
        }
       }
       else if (a.subResourceType === b.subResourceType) {
        if (a.additionalFields || b.additionalFields) {
          return a.additionalFields === b.additionalFields;
        } else {
          return true;
        }
      }
      } else {
        return true;
      }
    }
    else {
      return false;
    }
  }

  public getPatientContextId() {
    return this._bundleCall.getPatientContextForInterpolation();
  }
  public registerIndepedantDatabindings(_dataBindings: Array<IdataBinding>) {
    const prefetch = lodashFilter(_dataBindings, function(o) { return ((o.prefetch === true) || (!o.hasOwnProperty('prefetch'))); });
    const interpolateAndfetch = lodashFilter(_dataBindings, function(o) {
      return  (o.hasOwnProperty('isDepandant') && (o.isDepandant === true)); });
    const noRestCallPickFromExisting = lodashFilter(_dataBindings, function(o) { return o.hasOwnProperty('pickerIdentifierPath'); });
    const resultinterpolateAndfetch = differenceWith(interpolateAndfetch, noRestCallPickFromExisting, isEqual);
    const actualPrefetch = differenceWith(prefetch, interpolateAndfetch, isEqual);
    this.registerQuery(actualPrefetch);
  }

  /**
   * This interpolate Object can hold data for current flow.
   * For a flow/route this instance should be updated with core data items which can be used down line
   * by mutiple query registers to use the interpolation mechanism.
   * @param routePayload This param contains the core data items sent from the initial load of the route.
   */
  public updateCurrentInstanceData(routePayload: any) {
    if (routePayload) {
      this.interpolateCoreObject = Object.assign({ } , this.interpolateCoreObject, routePayload);
    }
  }

  private  customEndpointPayload(temDatabinding: IdataBinding, formData: any, reqbody: any, customInterpolation: any = { }): any {
      let postPayload = '';
      if (temDatabinding.postPayload) {
        const postPayloadStr = JSON.stringify(temDatabinding.postPayload);
        if (isEmpty(customInterpolation)) {
          postPayload = this._bundleCall.interpolate(postPayloadStr, formData);
        }
        else {
          postPayload = this._bundleCall.interpolate(postPayloadStr, customInterpolation);
        }
        postPayload = JSON.parse(postPayload);
      } else {
        postPayload = reqbody;
      }

    return postPayload;
  }

  // Todo need to remove
  public saveFormData(formId: string, formDataToSave: any, context: Array<Icontext> = [], flattenType = 'proper', customInterpolation = { }): Observable<any> {
    if (flattenType === 'proper') {
      return this._flattenService.flattenProper(formId, formDataToSave, [], true).switchMap((flattenData) => {
        return this.UpdateDataToServer(flattenData, context, customInterpolation);
      });
    }
    else {
      return this._flattenService.flatten(formId, formDataToSave, [], true).switchMap((flattenData) => {
        return this.UpdateDataToServer(flattenData, context, customInterpolation);
      });
    }
  }


  public registerForTestBarButtonStatus(componentName: string, status?: boolean) {
    this.buttonStatusMap.set(componentName, status ? status : false);
  }

  public unRegisterToTestBarButton(componentName: string) {
    this.buttonStatusMap.delete(componentName);
  }

  public enableDisableTestBarButton(componentName: string, status: boolean) {
    if (this.buttonStatusMap.size > 0 && this.buttonStatusMap.has(componentName)) {
      const prevMap: Map<String, boolean> = cloneDeep(this.buttonStatusMap);
      this.buttonStatusMap.set(componentName, status);
      if (!isEqualWith(this.buttonStatusMap, prevMap,
        (o1: Map<string, boolean>, o2: Map<string, boolean>) => o1.keys() === o2.keys())) {
        let combinedStatus: boolean = false;
        if (Array.from(this.buttonStatusMap.values()).filter(status => !status).length === 0) {
          combinedStatus = true;
        }
        let testBarSubscription = this.testStore$.select('testBar').take(1).subscribe(testBar => {
          let confirmButtonEnabled = get(testBar, 'confirmButtonEnabled');
          if (confirmButtonEnabled != combinedStatus) {
            this.store$.dispatch({
              type: TestBarActionTypes.EnableConfirmButton,
              payload: combinedStatus
            });
          }
          if (testBarSubscription) {
            testBarSubscription.unsubscribe();
          }
        });

      }
    }
  }

  /**
   * Post save data perform actions
   * @param data
   * @param queries
   */
  postSaveHooks(data: any, queries: Array<IdataBinding>) {
    if (queries && queries.length > 0) {
      let index = findIndex(queries, function (o) {
        return o.hasOwnProperty('postSaveHook');
      });
      let dataBindingWithWorkflowConfig = get(queries, [index]);
      let result = true;
      if(get(dataBindingWithWorkflowConfig, 'postSaveHook.formula')){
        let dataToEvaluate = get(data, [index]);
        result = FormulaService.evaluateFormula(get(dataBindingWithWorkflowConfig, 'postSaveHook.formula'), dataToEvaluate, false);
      }
      let postSaveHookActionType = get(dataBindingWithWorkflowConfig, 'postSaveHook.actionType');
      switch (postSaveHookActionType) {
        case 'performWorkFlowStep':
            let currentStep = get(dataBindingWithWorkflowConfig, 'postSaveHook.workflowConfig.activeStep', undefined);
            let moveToStep = get(dataBindingWithWorkflowConfig, 'postSaveHook.workflowConfig.moveToStep', false);
            let origin = get(dataBindingWithWorkflowConfig, 'postSaveHook.workflowConfig.origin', undefined);
            if (currentStep && result) {
              this._workflowUtilService.performWorkFlowStep(currentStep, moveToStep, null, origin, null);
            }
          break;
      }
      this.formUpdatedNotification$.next();
    }
  }


  public getFacilities():Observable<IfacillitiesInfo>{
    const isFacilityinOrgEnabled = this.usersKeystore$.select('organizationConfiguration').filter(alldata => !isEmpty(alldata));
    const isFacilityinAppEnabled =  this.genomicsStore.select('navigation', 'currentApp').filter(alldata => !isEmpty(alldata));
    const currentUser =  this.usersKeystore$.select('currentUser').filter(alldata => !isEmpty(alldata));

     return  combineLatest(isFacilityinOrgEnabled,isFacilityinAppEnabled,currentUser).map(data => {
       let { currentFacilities,currentActiveFacilities,currentAssociatedFacilities,currentAssociatedActiveFacilities,selectedFacilities } = get( data,'2');

      const isFacilityEnabled =  this.checkIfFacility(get(data,'0'),get(data,'1'),currentFacilities);
       if(get(selectedFacilities,'0.id') === "all") {
         selectedFacilities = currentAssociatedFacilities;
       }
      const returnObj :IfacillitiesInfo = {isFacilityEnabled,currentFacilities,currentActiveFacilities,currentAssociatedFacilities,currentAssociatedActiveFacilities,selectedFacilities};
      return returnObj;
    });
  }

  public getSelectedFacilities():Observable<any>{
   return this.genomicsStore.select('users').pipe(distinctUntilKeyChanged('selectedFacilities')).map((user) => {
     return {'selectedFacilities':get(user,'selectedFacilities',[]),association:get(user,'association',false)  };
   });
  }

  public isFacilityActive():Observable<boolean>{
    const isFacilityinOrgEnabled = this.usersKeystore$.select('organizationConfiguration');
    const isFacilityinAppEnabled =  this.genomicsStore.select('navigation', 'currentApp');
    const currentAssociatedActiveFacilities = this.usersKeystore$.select('currentUser').pipe(filter((user) => !isEmpty(user)),distinctUntilKeyChanged('currentAssociatedActiveFacilities'));

    const combined = combineLatest(isFacilityinOrgEnabled,isFacilityinAppEnabled,currentAssociatedActiveFacilities).map(data => {
      return this.checkIfFacility(get(data,'0'),get(data,'1'),(get(data,'2.currentAssociatedActiveFacilities',[])));
    });
    return combined;
  }

  public isFacilityActiveWithoutAssociation():Observable<boolean>{
    const isFacilityinOrgEnabled = this.usersKeystore$.select('organizationConfiguration');
    const isFacilityinAppEnabled =  this.genomicsStore.select('navigation', 'currentApp');
    const combined = combineLatest(isFacilityinOrgEnabled,isFacilityinAppEnabled).map(data => {
      return this.checkIfFacility(get(data,'0'),get(data,'1'),['dummyAssociation']);
    });
    return combined;
  }

  public keysRenaming(items:any,keyMap:object):any {
    return arrayKeyRenaming(items,keyMap)
  }

  public isInoActiveWithoutAssociation(): Observable<boolean> {
    return this.usersKeystore$.select('organizationConfiguration').distinctUntilChanged().pipe(
      map((data: any) => {
        // Check if organizationConfiguration exists and isInoEnabled is true
        const isInoEnabled = get(data, 'isInoEnabled', false);
        return isInoEnabled === true;
      })
    );
  }

  private checkIfFacility(orgconfig,appconfig,currentFacilities):boolean{
    const isFacilityinAppDisabled = get(appconfig,'facilityDisable',false);
    const isFacilityinOrgEnabled = get(orgconfig,'isFacilityEnabled',false);
    if(isFacilityinOrgEnabled) {
      if (isFacilityinAppDisabled){
        return false;
      }
      else {
        return currentFacilities?(currentFacilities.length>0):false;
      }
    }else {
      return false;
    }
  }
  public updateFacilities(selectedFacilities:Array<Ifacillity>, association: string,applied:boolean){
    let _selectedFaciity = get(selectedFacilities,'0.id'); // Picking only 0th is because only one facility selection at once
    let selectedFacilitiesString = '';
    if(_selectedFaciity == "all"){
      let currentAssociatedActiveFacilities:Array<Ifacillity> = get(this.currentUser,'currentAssociatedActiveFacilities',[]);
      if(isEmpty(currentAssociatedActiveFacilities)){
        selectedFacilitiesString = "noActiveFacilityForThisUser";
      } else {
        selectedFacilitiesString = Array.prototype.map.call(currentAssociatedActiveFacilities, s => s.id).toString();
      }
    } else {
      selectedFacilitiesString = _selectedFaciity;
    }
    this.userAC.setSelectedFacilities({selectedFacilities,selectedFacilitiesString,association,applied});
  }

  public getCurrentManagedFacility():Observable<Ifacillity> {
      return this.testStore$.select('diagnosticOrders','order').pipe(distinctUntilKeyChanged('managingFacility')).switchMap((order) =>  {

        const managinFacility = get(order,'managingFacility');
        if(managinFacility){
          let currentFacilities:Array<Ifacillity> = get(this.currentUser,'currentFacilities',[]);
          return of(currentFacilities.find(item => item.id === managinFacility));
        }
       else {
          return this.genomicsStore.select('users').map(user => {
            return get(user,'selectedFacilities',[])[0];
          });
        }
      });

  }

  public getSelectedFacilityStringAndAssociation():Observable<ISelectedFacilityAssociation>{
    return this.isFacilityActive().switchMap((isActive) =>{
      return this.genomicsStore.select('users').pipe(distinctUntilChanged((prev, curr) => {
        let changed:boolean = true;
         if(get(prev,'selectedFacilitiesString') !== get(curr,'selectedFacilitiesString')){
           changed = false;
         } else if(get(prev,'association') !== get(curr,'association')) {
           changed = false;
         }
         return changed;
      })).map(user => {
        return {selectedFacilitiesString:get(user,'selectedFacilitiesString',null),association:(get(user,'association') != "managedByFacility"),applied:get(user,'applied',false),active:isActive}
      })
    });

  }


  public getDefaultWorklistFilter():Observable<string>{
    return this.usersKeystore$.select('currentUser').pipe(filter((user) => !isEmpty(user)),distinctUntilKeyChanged('currentAssociatedActiveFacilities')).switchMap((user) => {
      return this.genomicsStore.select('navigation', 'currentApp').pipe(distinctUntilKeyChanged('facilityWorklistFilters')).map((app) => {
        return get(app, 'facilityWorklistFilters.defaultFilter') ;
      });
    })
   }

}
